import styled from 'styled-components'
import { SpecialOutlineButton } from '@chegg-wt/core/theme/fanta/button'
import OVisibleOnHoverWrapper from '@chegg-wt/core/components/VisibleOnHoverWrapper'
import { font, spacing } from '@chegg-ui/theme'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { TimesNewRomanStack } from '@chegg-wt/core/theme/sunkist/fonts'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'

export interface CitationContainerProps {
  isNew: boolean
  isIncomplete: boolean
}

export const CitationContainer = styled.div<CitationContainerProps>`
  ${({ isIncomplete, isNew, theme }) => {
    if (isIncomplete) {
      return `
        background-color: ${theme.Colors.forInterface.interfaceColor07};
        &:hover {
          background-color: rgba(255, 245, 198, 0.5);
        }
      `
    }
    if (isNew) {
      return `
        background-color: ${theme.Colors.forInterface.interfaceColor08};
        &:hover {
          background-color: rgba(222, 252, 227, 0.5);
        }
      `
    }
    return ''
  }};
  padding: ${values.xsmall};
  border-radius: 6px;
`

export const CitationWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const CheckboxWrapper = styled.div``

export const CitationText = styled.p`
  ${TimesNewRomanStack};
  margin-left: 1cm;
  text-indent: -0.7cm;
  padding: 0 ${values.xxsmall};
  display: inline-block;
  width: calc(100% - 1cm);
  word-break: break-word;
  line-height: 180%;
  span {
    text-indent: 0cm;
    display: block;
    margin-top: 16px;
  }

  -webkit-touch-callout: none;
  user-select: none;

  > * {
    ${TimesNewRomanStack};
  }
`
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DismissibleButtons = styled.div`
  display: none;
  top: -25%;
  left: 25%;
  position: absolute;
`

export const SpacedText = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 30px); /* -30px is to discount MenuButton width */
  position: relative;
  &:hover ${CitationText} {
    color: ${({ theme }) => theme.Colors.forFonts.fColor18};
    opacity: 0.5;
  }
`

export const VisibleOnHoverWrapper = styled(OVisibleOnHoverWrapper)`
  width: calc(100% - 30px); /* -30px is to discount MenuButton width */
`

export const CopyContainer = styled.div`
  margin-right: ${spacing.px12};
`

export const InTextCopyContainer = styled(CopyContainer)`
  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), -1)}) {
    display: none;
  }
`

export const CopyButton = styled(SpecialOutlineButton)`
  font-size: ${font.size.px16};
`
